export const capitalize = (str) => {
    if (!str) return ""

    return str
        .split(" ")
        .map((word) => {
            if (word.length <= 4) {
                return word.toUpperCase()
            } else {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            }
        })
        .join(" ")
}